import React, { useState } from 'react';
import { array, func, string } from 'prop-types';
import styled from 'styled-components';
import { get, map, remove } from 'lodash';
import Button from '../Button';
import { Column, Row } from '../Grid';
import { FormInput } from '../Input/Input';
import Icon from '../Icon';
import Text from '../Text';

const InfoTag = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    padding: 4px 8px;
    gap: 8px;
    height: 24px;
    background: #1FA02E;
    border-radius: 16px;
`;

const InputItemList = ({ data, onChange, justify, placeholder = 'Ingrese EAN', label = '' }) => {
    const [itemStore, setItemStore] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    return (
        <Column>
            <Row justify={justify} align='end'>
                <FormInput
                    label={label}
                    onChange={value => {
                        setItemStore(get(value, 'target.value'));
                        setErrorMessage('');
                    }}
                    width='auto'
                    style={{ margin: 0 }}
                    placeholder={placeholder}
                />
                <Button
                    fitContent
                    left={5}
                    onClick={() => {
                        if (itemStore) {
                            if ((data || []).includes(itemStore)) {
                                setErrorMessage('El email ya existe en la lista');
                            } else {
                                onChange([...(data || []), itemStore]);
                                setErrorMessage('');
                            }
                        }
                    }}
                >
                    <Icon name='plus' color='#ffffff' />
                </Button>
            </Row>
            {errorMessage && (
                <Row justify={justify} mT={5}>
                    <Text text={errorMessage} color='#db5959' />
                </Row>
            )}
            <Row justify={justify} gap={3} mT={5}>
                { map((data || []), (element, index) => (
                    <InfoTag key={index}>
                        <Text text={element} color='white' semibold />
                        <Icon name='close' color='white' size={15} pointer onClick={() => onChange(remove(data, item => item !== element))} />
                    </InfoTag>
                )) }
            </Row>
        </Column>
    );
};

InputItemList.propTypes = {
    data: array,
    onChange: func,
    justify: string
};

InputItemList.defaultProps = {
    data: [],
    onChange: () => {}
};

export default InputItemList;
